// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__y-wOX","nav__btn-wrapper":"Navbar_nav__btn-wrapper__EQ7Jq","nav__counter":"Navbar_nav__counter__mwStc"};